import api from './axios';

/**
 * Commission payouts (spec §8.3).
 *
 * `previewPayout` exists so the member sees their promised credit date BEFORE
 * confirming — that date comes from the server's banking calendar (Rule 74) and
 * must never be recomputed in the browser.
 */
export const previewPayout = ()                => api.get('/v1/payouts/preview');
export const listPayouts   = (params = {})     => api.get('/v1/payouts', { params });
export const requestPayout = (payload = {})    => api.post('/v1/payouts/request', payload);

/** decision: 'release' | 'reject'. The server recomputes the net and rejects a mismatch. */
export const decidePayout  = (payoutId, payload) => api.post(`/v1/payouts/${payoutId}/release`, payload);

/**
 * Moves a payout's promised credit date (Rule 74).
 *
 * The member was TOLD a date, so changing it is an explicit, audited act with a
 * stated reason — never a side effect. The server re-normalises the new date to
 * a banking day, so an admin cannot promise a Sunday.
 */
export const reschedulePayout = (payoutId, payload) =>
  api.post(`/v1/payouts/${payoutId}/reschedule`, payload, {
    headers: { 'Idempotency-Key': (crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`) },
  });

